module.exports = "/_next/static/images/DataPrivacy-a86397f7224a886fd1730bef9bff621d.png";